import { UserGetters } from "./types";

const userGetters: UserGetters = {
  micImplementation(state: any, getters: any, rootState: any) {
    const useOnlyHttp = rootState.user?.profile?.useOnlyHttp;

    return useOnlyHttp ? "SttQueue" : "MicrosoftSdk";
  }
};

export { userGetters };
